module.exports = __webpack_public_path__ + "img/car-illustration.c00ee28e.svg";